import Axios from '@/utils/request'
import { addSign } from "@/utils/tools"


// 登录接口
export const loginApi = (params) => Axios.post('station/pdah5/v1/gasUser/login', params);
// token登录接口
export const tokenLoginApi = (params) => Axios.post('station/pdah5/v1/gasUser/tokenLogin', params);

// 修改密码接口
export const editPwdApi = (params) => Axios.post('station/pdah5/v1/gasUser/editPassword', params)

// 登出接口
export const logOutApi = (params) => Axios.post('station/pdah5/v1/gasUser/loginOut', params)

// 加油员绑定微信接口
export const wxBindApi = (params) => Axios.post('station/pdah5/v1/gasUser/bindGasUserWx', params)

// 加油员解绑微信接口
export const wxUnbindApi = (params) => Axios.post('station/pdah5/v1/gasUser/unbindGasUserWx', params)

// 获取jssdk验签接口
export const jsSdkApi = (params) => Axios.get(`station/pdah5/v1/gasUser/wxJSSDKSignature?${addSign(params)}`)

//二维码解码接口
export const decodeQRApi = (params) => Axios.post('order/pdah5/qrCode/v1/parse', params)

//修改语音播报状态接口
export const voiceChangeApi = (params) => Axios.post('station/pdah5/v1/gasUser/broadcastVoice', params)

// 获取加油员信息
export const getUserInfoApi = (params) => Axios.post('station/pdah5/v1/gasUser/getUserInfo', params)

